import React from "react";
import { FormControl, FormHelperText } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import Select from "material-ui/Select";
import "./index.css";

const SelectField = ({ input, label, meta: { touched, error }, children, options = [], ...custom }) => (
  <FormControl className="select-field">
    <InputLabel>{label}</InputLabel>
    <Select
      error={touched && !!error}
      {...input}
      {...custom}
      native
      onBlur={() => {
        input.onBlur(input.value);
      }}
    >
      <option value="">
        <em>None</em>
      </option>
      {options.map(({ value, name }) => (
        <option key={value} value={value}>
          {name}
        </option>
      ))}
    </Select>
    {touched && !!error && <FormHelperText error>{error}</FormHelperText>}
  </FormControl>
);
export default SelectField;



// WEBPACK FOOTER //
// ./src/components/FormElements/SelectField/index.js